import * as r from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/Printer.es.js";
const e = r.forwardRef((o, t) => /* @__PURE__ */ r.createElement(n, { ref: t, ...o, weights: a }));
e.displayName = "PrinterIcon";
const c = e;
export {
  c as Printer,
  e as PrinterIcon
};
